import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import { BallTriangle } from 'react-loader-spinner';
import { groupBy, keys, size } from 'underscore';
import { Context } from '../..';
import DocumentsService from '../../services/DocumentsService';
import { ModalPopover } from './modal/modal-popover';
import { DocsEditModal } from "./modal/DocsEditModal";
import { API_URL } from '../../appConfig';



const Doc: FC<any> = observer(({ doc, setDelDocId, setDelDocModal }) => {
    const { store } = useContext(Context)
    const [docEditModal, setDocEditModal] = useState<boolean>(false);

    return (
        <div className='row m-3'>
            <hr />
            <div className="col">
                <a href={API_URL + doc['url']} className="doc-link" target="_blank" rel="noreferrer" download>
                    <div className="h6">{doc['name']}</div>
                    <div>
                        <span className="small me-1 text-primary"><Trans>Date</Trans>:</span>
                        <span className="small me-1">{doc['date']}</span>
                        <span className="small me-1 text-primary"><Trans>Chapter</Trans>:</span>
                        <span className="small me-1">{doc['chapter']['chapter']}</span>
                        <span className="small me-1 text-primary"><Trans>Publisher</Trans>:</span>
                        <span className="small me-1">{doc['publisher']['publisher']}</span>
                        <span className="small me-1 text-primary"><Trans>Status</Trans>:</span>
                        <span className="small me-1">{doc['status']['status']}</span>
                    </div>
                </a>
            </div>
            {store.user.is_superuser ?
                <div className="col-md-1">
                    <i className='icon admin ms-3' onClick={() => {
                        setDocEditModal(true)
                    }} />
                    <i className='icon trash' onClick={() => {
                        setDelDocId(doc['id']);
                        setDelDocModal(true);
                    }} />
                </div>
                : null}
            <DocsEditModal doc={doc} toggle={docEditModal} setToggle={setDocEditModal} />
        </div>

    )
});

const ChapterItem: FC<any> = observer(({ chapter, documents, setDelDocId, setDelDocModal }) => {

    const docs = documents[chapter];

    const getDocs = () => docs.sort((a: any, b: any) => (b['id'] - a['id'])).map((doc: any, i: number) => {
        return <Doc key={i} {...{ doc, setDelDocId, setDelDocModal }} />
    })

    return (
        <div className='row'>
            <div className="h5 mt-5">
                Раздел: {chapter}
            </div>
            {getDocs()}
            <hr />
        </div>
    )
});

const ForSpecialistsMaterials: FC = () => {
    const { store } = useContext(Context)
    const [documents, setDocuments] = useState({});
    const [delDocId, setDelDocId] = useState<number>(-1);
    const [delDocModal, setDelDocModal] = useState<boolean>(false);
    const [fix, setFix] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);


    const getDocs = async () => {
        const res = await DocumentsService.getDocsByType(3, 0);
        setDocuments(groupBy(res.data.results, (obj) => obj['chapter']['chapter']));
        setLoader(false);
    }

    useEffect(() => {
        setLoader(true);
        getDocs();
        setFix(false);
    }, [fix]);

    const deleteDoc = async () => {
        await DocumentsService.removeDocument(delDocId);
        setFix(true);
        setDelDocModal(false);
        setDelDocId(-1);
    };


    const getDocuments = () => {
        if (documents && size(documents)) {
            return keys(documents).map((chapter: any, i: number) => {
                return (
                    <ChapterItem key={i} {...{ chapter, documents, setDelDocId, setDelDocModal }} />
                );
            });
        }
    };

    return (loader ? <div className='row justify-content-center'><div className='col-md-2 mt-5'><BallTriangle color="#1d7ea7" height={90} width={90} /></div></div> :
        <div>
            <h6 className='p-3 text-center'>Материалы для специалистов</h6>
            <div className="row form-group">
                {getDocuments()}
            </div>

            <ModalPopover
                toggle={delDocModal}
                setToggle={setDelDocModal}
                title={store.lang === 'ba' ? 'Файлды алып ташлау' : store.lang === 'ru' ? 'Удаление файла' : 'Deleting a file'}
                modalContent={<Trans>Do you want to delete a file?</Trans>}
                clickedButtonOne={() => deleteDoc()}
                clickedButtonTwo={() => { setDelDocModal(false); setDelDocId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
        </div>
    );
};
export default observer(ForSpecialistsMaterials);